import { getUniqueIdentifier } from "../../utils/GUID";
import { AdventureEvent } from "../adventures/AdventureEvent";

export type ToastType = 'success' | 'info' | 'warning' | 'error';
export type ToastMessage = string | AdventureEvent;

export type Toast = {
    id: string;
    message: ToastMessage;
    type: ToastType;
}

export abstract class ToastLegacy implements Toast {
    public constructor(
        public readonly message: ToastMessage,
        public readonly type: ToastType
    ) {
        this.id = getUniqueIdentifier();
    }

    public readonly id: string;
}

export class SuccessToast extends ToastLegacy {
    public constructor(public readonly message: ToastMessage) {
        super(message, 'success');
    }
}

export class InfoToast extends ToastLegacy {
    public constructor(public readonly message: ToastMessage) {
        super(message, 'info');
    }
}

export class WarningToast extends ToastLegacy {
    public constructor(public readonly message: ToastMessage) {
        super(message, 'warning');
    }
}

export class ErrorToast extends ToastLegacy {
    public constructor(public readonly message: ToastMessage) {
        super(message, 'error');
    }
}

const messageIsString = (message: ToastMessage): message is string => {
    return typeof message == "string";
}

const messageIsAdventureEvent = (message: ToastMessage): message is AdventureEvent => {
    return typeof message != "string";
}

export const TOAST_HELPERS = Object.freeze({
    messageIsString,
    messageIsAdventureEvent,
})